<template>
  <div class="ranking_container">
    <div class="ranking_header" v-if="shouldShowHeader">
      <p>{{ $t('audienceRankingTitle') }}</p>
    </div>
    <p class="ranking_pointDescription">
      {{ $t('audienceRankingDescription') }}
    </p>
    <ranking-tab
      v-if="payload !== undefined"
      :rankingData="payload"
    ></ranking-tab>
  </div>
</template>

<script>
import APIRequest from '@/utils/APIRequest'
import RankingTab from '@/components/AudienceRanking/RankingTab.vue'
import i18n from '@/i18n'

export default {
  components: {
    RankingTab,
  },
  title: i18n.t('audienceRankingTitle'),
  name: 'Ranking',
  computed: {
    shouldShowHeader: function () {
      return this.$route.query.tp !== 'avatar'
    },
  },
  created() {
    this.fetchAudienceEvent()
  },
  data: function () {
    return {
      payload: [
        {
          rankers: [],
          ranking_type: 3,
        },
      ],
    }
  },
  methods: {
    fetchAudienceEvent: async function () {
      var params = {
        streamer_vlive_id: this.$route.params.vliveId,
      }

      if (this.$route.query.av !== undefined) {
        params.vlive_id = this.$route.query.av
      }

      if (this.$route.query.mi !== undefined) {
        params.media_id = this.$route.query.mi
      }

      const response = await this.$loader.post(
        new APIRequest(
          this.$config.mediaServerUrl,
          '/audience_event/list_published',
          params
        )
      )

      this.payload = response

      setTimeout(() => {
        this.fetchAudienceEvent()
      }, 30000)
    },
  },
}
</script>

<style scoped>
.ranking_container {
  width: 100%;
  position: fixed;
}

.ranking_header {
  text-align: center;
  height: 26px;
  margin: 12px 12px 0;
  font-size: 17px;
  font-weight: bold;
}

.ranking_tabContainer {
  height: 40px;
}

.ranking_pointDescription {
  color: rgb(128, 128, 128);
  margin-top: 4px;
  font-size: 10px;
  text-align: center;
}
</style>
